import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupService } from '../services/signup.service';
import { TokenStorage } from '../../core/token.storage';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '../../common/services/authorization.service';



@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
constructor(private authorizationService: AuthorizationService, private router: Router, private authService: SignupService, private token: TokenStorage, private toastr: ToastrService) { }
  numSouscript: string;
  tel: string;
  loginForm: FormGroup;

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.loginForm = new FormGroup({
            // tslint:disable-next-line
            numSouscript: new FormControl('', [Validators.required, Validators.pattern('')]),
            tel: new FormControl('', Validators.required),
        });
    }

    loginUp(): void {
        this.authService.attemptAuth(this.numSouscript, this.tel).subscribe(
            (data) => {

                if (data == '2000'){
                    this.token.saveUserID(this.numSouscript);
                    
                    this.router.navigate(['validation']);
                    //this.showSuccess();
                }
                else if(data == '1002'){
                    this.router.navigate(['validation']);
                    this.showPhoneError();
                }
                else if(data == '1001'){
                    this.router.navigate(['login']);
                    this.showExistError();
                }
                else{
                    this.router.navigate(['signup']);
                    this.showCrossError();
                }
                
            }
            

        );
    }

    // For Toatr. 
    showSuccess() {
        this.toastr.success('Compte crée avec succès, veuillez entrer vos identifiants pour vous connecter!', 'Création de compte');
      }

    // For Toatr. 
    showPhoneError() {
        this.toastr.success("Le numéro de téléphone saisie n'est pas enregistré auprès de la SONAVIE. Veuillez contacter la SONAVIE pour récupérer votre code de validation.", 'Création de compte');
      }

      // For Toatr. 
    showCrossError() {
        this.toastr.error("Une erreur s'est produit lors de la création du compte, veuillez verifier vos informations.", 'Erreur de connexion');
      }
      showExistError(){
        this.toastr.error("Vous avez déjà un compte, veuillez entrer vos identifiants.", 'Création de compte');

      }

}



// WEBPACK FOOTER //
// ./src/app/client-app/signup/signup.component.ts